// ./api/recognizedInstructorAPI.js

import axiosInstance from '../utilities/axiosInstance';

const recognizedInstructorAPI = {
  // ============================================================================
  // RECOGNIZED INSTRUCTOR MANAGEMENT
  // ============================================================================

  // Create a new recognized instructor
  createInstructor: async (instructorData) => {
    try {
      const response = await axiosInstance.post('/api/recognized-instructor/create', instructorData);
      // console.log("creat instructor api ok ", response);
      return response.data; // {success, message, data}
    } catch (error) {
      // console.log("creat instructor api not ok ", error);
      return error?.response?.data || { 
        success: false, 
        error: `Failed to create recognized instructorAPI: ${error.message}` 
      };
    }
  }, 

  // Get instructor by email
  getInstructorByEmail: async (email) => {
    try {
      const response = await axiosInstance.get(`/api/recognized-instructor/info/${email}`);
      return response.data; // {success, data}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get instructor: ${error.message}` 
      };
    }
  },

  // Get all recognized instructors
  getAllInstructors: async () => {
    try {
      const response = await axiosInstance.get('/api/recognized-instructor/all');
      return response.data; // {success, data, count}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get instructors: ${error.message}` 
      };
    }
  },

  // Update instructor information
  updateInstructor: async (email, updateData) => {
    // console.log("creat instructor api ", updateData);

    try {
      const response = await axiosInstance.put(`/api/recognized-instructor/update/${email}`, updateData);
      return response.data; // {success, message, data}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to update instructor: ${error.message}` 
      };
    }
  },

  // Delete recognized instructor
  deleteInstructor: async (email) => {
    try {
      const response = await axiosInstance.delete(`/api/recognized-instructor/delete/${email}`);
      return response.data; // {success, message, data}
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to delete instructor: ${error.message}` 
      };
    }
  },

  // Check if email is recognized (helper function)
  isRecognizedInstructor: async (email) => {
    try {
      const response = await axiosInstance.get(`/api/recognized-instructor/info/${email}`);
      console.log("isRecognizedInstructor1 :", response.data.success)
      return response.data.success; // Returns true if instructor exists
    } catch (error) {
      return false;
    }
  }
};

export default recognizedInstructorAPI;